import React, {useEffect, useState} from 'react';
import { useTheme } from '@mui/joy';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import taxonomyNameActions from 'actions/taxonomyNameActions';
import observationActions from 'actions/observationActions'
import Sheet from 'components/core/Sheet';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import TaxonomyDossier from 'components/TaxonomyDossier';
import ObservationsTable from 'components/ObservationsTable';

import Stack from 'components/core/Stack';

const TaxonomyView = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { taxonomyNameId } = useParams();
    const taxonomyName = useSelector(({ taxonomyName }) => taxonomyName.current);
    const taxonomyNameSynonyms = useSelector(({ taxonomyName }) => taxonomyName.list);
    const observations = useSelector(({ observation }) => observation.list);
    const pagination = useSelector(({ observation }) => observation.pagination);
    const isLoading = useSelector(({ observation }) => observation.isLoading);
    const [pageSize] = useState(20);

    // first and last observations need to be decided by date not orderNOT FUCKING ORDER
    const sortedObservations = observations.sort((a, b) => {
        const aDate = new Date(a.get('date') || 0);
        const bDate = new Date(b.get('date') || 0);
        return aDate - bDate;
    });

    const firstObservation = sortedObservations[0] || null;
    const lastObservation = sortedObservations[sortedObservations.length - 1] || null;
    
    useEffect(() => {
        dispatch(taxonomyNameActions.get(taxonomyNameId)).then((getResult) => {
            if (!getResult) return;
            const taxonomy = getResult.value.taxonomy
            dispatch(taxonomyNameActions.listSynonyms(taxonomy)).then((listSynonymsResult) => {
                if (!listSynonymsResult) return;
                const taxonomyNameSynonymsResults = listSynonymsResult.value
                if (taxonomyNameSynonymsResults && taxonomyNameSynonymsResults.length > 0) {
                    dispatch(observationActions.list({ 
                        names: taxonomyNameSynonymsResults,
                        page: 1,
                        pageSize: pageSize
                    }));
                }
            })
        })
    }, [taxonomyNameId, pageSize]);

    useEffect(() => {
        return () => {
            dispatch(observationActions.clearList());
        };
    }, [dispatch]);

    const loadMoreObservations = () => {
        if (!pagination.hasMore) return;
        
        dispatch(observationActions.list({ 
            names: taxonomyNameSynonyms,
            page: pagination.page + 1,
            pageSize: pagination.pageSize,
            loadMore: true
        }));
    };

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mx: { xs: 1, sm: 1, md: 5, lg: 10, xl: 30 }
            }}
        >
            <Sheet sx={{width: '100%', background: 'none'}}>
                <Button
                    variant="text" 
                    onClick={() => navigate(-1)}
                    sx={{ padding: 0}}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        <ArrowBackIosIcon
                            sx={{ color: 'black', fontSize: 18, mt: 2}}
                        />
                        <Typography sx={{ fontSize: 18 }}>Back</Typography>
                    </Stack>
                </Button>

            </Sheet>
            <TaxonomyDossier
                taxonomy={taxonomyName?.get('taxonomy')}
                taxonomyNameSynonyms={taxonomyNameSynonyms}
                firstObservation={firstObservation}
                lastObservation={lastObservation}
            />
            <ObservationsTable
                showDownloadButton={true}
                observations={observations}
                taxonomyNameId={taxonomyNameId}
                onLoadMore={loadMoreObservations}
                hasMoreRecords={pagination.hasMore}
                isLoading={isLoading}
                totalCount={pagination.total}
            />
        </Stack>
    );
};

export default TaxonomyView;